/* Load more / infinite scroll — theme clone of Magepow InfiniteScroll. Config: sections/load-more.liquid. */
(function () {
  function cfg() {
    var c = document.querySelector('[data-load-more-config]');
    var d = c ? c.dataset : {};
    return { offset: parseInt(d.offset || '-1', 10), autoLink: d.autoLink === 'true', blog: d.blog === 'true',
      btn: d.buttonText || '', prev: d.prevText || '', loading: d.loadingText || '' };
  }
  function lists(c) { return document.querySelectorAll(c.blog ? 'product-list, blog-posts' : 'product-list'); }
  function isItem(list, el) { return list.tagName === 'PRODUCT-LIST' ? el.tagName === 'PRODUCT-CARD' : el.nodeType === 1; }
  function pageOf(url) { try { return parseInt(new URL(url, location.href).searchParams.get('page') || '1', 10); } catch (e) { return 1; } }
  function linkFor(root, n) {
    var a = root.querySelectorAll('nav.pagination a');
    for (var i = 0; i < a.length; i++) if (pageOf(a[i].href) === n) return a[i].href;
    return null;
  }
  function loaderHtml() { var t = document.querySelector('template[data-lm-loader]'); return t ? t.innerHTML : ''; }

  function setup(list) {
    if (list.dataset.lmReady) return;
    list.dataset.lmReady = '1';
    var c = cfg();
    var scope = list.closest('.shopify-section') || document;
    var nav = scope.querySelector('nav.pagination');
    if (!nav) return;
    var cur = pageOf(location.href);
    var nextUrl = linkFor(scope, cur + 1), prevUrl = linkFor(scope, cur - 1);
    var nextPage = cur + 1, prevPage = cur - 1;
    scope.querySelectorAll('.lm-zone').forEach(function (z) { z.remove(); });
    nav.classList.add('lm-hidden-pagination');

    function zone(cls) { var z = document.createElement('div'); z.className = 'lm-zone ' + cls; return z; }
    var spinner = zone('lm-spinner'); spinner.innerHTML = loaderHtml() + (c.loading ? '<em></em>' : ''); spinner.hidden = true;
    if (c.loading) spinner.querySelector('em').textContent = c.loading;
    var more = zone('lm-more'); var b = document.createElement('button'); b.type = 'button'; b.className = 'lm-btn'; b.textContent = c.btn; more.appendChild(b); more.hidden = true;
    var end = zone('lm-end'); end.hidden = true;
    var top = document.createElement('button'); top.type = 'button'; top.className = 'lm-top'; top.setAttribute('aria-label', 'Top'); top.innerHTML = '<span></span><span></span>';
    top.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); }); end.appendChild(top);
    var sentinel = document.createElement('div'); sentinel.className = 'lm-zone lm-sentinel'; sentinel.style.cssText = 'padding:0;height:1px';
    var after = list.nextSibling;
    [sentinel, spinner, more, end].forEach(function (z) { list.parentNode.insertBefore(z, after); });

    var prevZone = null, pb = null;
    if (prevUrl && c.prev) {
      prevZone = zone('lm-prev'); pb = document.createElement('button'); pb.type = 'button'; pb.className = 'lm-btn'; pb.textContent = c.prev; prevZone.appendChild(pb);
      list.parentNode.insertBefore(prevZone, list);
    }

    var first = Array.prototype.find.call(list.children, function (el) { return isItem(list, el); });
    if (first) first.dataset.lmPage = String(cur);
    var autoLeft = c.offset < 0 ? Infinity : c.offset;
    var busy = false;

    function items(doc) {
      var src = doc.querySelector(list.tagName.toLowerCase());
      if (!src) return [];
      /* blog: the featured (large) copy of each page's first article is skipped — its regular card is kept */
      return Array.prototype.filter.call(src.children, function (el) { return isItem(list, el) && !el.classList.contains('featured-blog-post'); });
    }
    function prep(el, page, isFirst) {
      var n = document.importNode(el, true);
      n.removeAttribute('reveal-on-scroll');
      if (isFirst) n.dataset.lmPage = String(page);
      return n;
    }
    function state() {
      if (!nextUrl) { more.hidden = true; end.hidden = false; if (io) io.disconnect(); return; }
      more.hidden = autoLeft > 0;
    }
    function loadNext(auto) {
      if (busy || !nextUrl) return;
      if (auto) { if (autoLeft <= 0) return; autoLeft--; }
      busy = true; spinner.hidden = false; more.hidden = true;
      fetch(nextUrl, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        items(doc).forEach(function (el, i) { list.appendChild(prep(el, nextPage, i === 0)); });
        nextPage++; nextUrl = linkFor(doc, nextPage);
        busy = false; spinner.hidden = true; state();
      }).catch(function () { busy = false; spinner.hidden = true; nav.classList.remove('lm-hidden-pagination'); more.hidden = true; });
    }
    function loadPrev() {
      if (busy || !prevUrl) return;
      busy = true;
      fetch(prevUrl, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var h0 = document.documentElement.scrollHeight;
        var ref = Array.prototype.find.call(list.children, function (el) { return isItem(list, el); });
        items(doc).forEach(function (el, i) { list.insertBefore(prep(el, prevPage, i === 0), ref); });
        window.scrollBy(0, document.documentElement.scrollHeight - h0);
        prevPage--; prevUrl = linkFor(doc, prevPage);
        if (!prevUrl && prevZone) prevZone.remove();
        busy = false;
      }).catch(function () { busy = false; });
    }
    b.addEventListener('click', function () { loadNext(false); });
    if (pb) pb.addEventListener('click', loadPrev);

    var io = null;
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (e) { if (e[0].isIntersecting) loadNext(true); }, { rootMargin: '800px 0px' });
      io.observe(sentinel);
    }
    state();
    if (!nextUrl) end.hidden = false;

    if (c.autoLink && window.history && history.replaceState) {
      var t = null;
      window.addEventListener('scroll', function () {
        if (t) return;
        t = setTimeout(function () {
          t = null;
          var marks = list.querySelectorAll('[data-lm-page]'), page = null;
          for (var i = 0; i < marks.length; i++) if (marks[i].getBoundingClientRect().top < window.innerHeight / 2) page = marks[i].dataset.lmPage;
          if (!page) return;
          var u = new URL(location.href);
          if ((u.searchParams.get('page') || '1') === page) return;
          if (page === '1') u.searchParams.delete('page'); else u.searchParams.set('page', page);
          history.replaceState(history.state, '', u.toString());
        }, 200);
      }, { passive: true });
    }
  }

  function scan() { var c = cfg(); lists(c).forEach(setup); }
  function init() {
    scan();
    var t = null;
    new MutationObserver(function () { if (t) return; t = setTimeout(function () { t = null; scan(); }, 150); }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
